import React, { useContext, useEffect, useMemo } from 'react'
import { Page, Text, View, Document, PDFViewer, Image, PDFDownloadLink, BlobProvider } from '@react-pdf/renderer';
import { v4 as uuid } from 'uuid';
import UserContext from '../../../context/Globales/UserContext';
import moment from 'moment';

const IcpdfDetalleVehiculos = () => {

    const { DatodetalleVehiculos, datoIC } = useContext(UserContext);



  moment.locale('spanish');
  const FechaImpresion = moment().format('LLLL'); // FORMATO: Domingo 15 Julio 2012 11:01


    const TblVehiculosResumen = (
        <>
            {DatodetalleVehiculos && DatodetalleVehiculos != null ?
                <View style={{ width: '50%' }}>

                    <View style={{ flexDirection: 'row', fontSize: 9, backgroundColor: '#e6e6e6', color: 'black' }}>

                        <Text style={{ width: '50%', height: '25px', padding: '1,10', textAlign: 'center' }}>Cant. Vehiculos</Text>




                    </View>
                    <View style={{ flexDirection: 'row', fontSize: 9 }} key={uuid()}>

                        <Text style={{ width: '50%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{DatodetalleVehiculos && DatodetalleVehiculos.Vehiculos?.CantidadVehiculos}</Text>

                    </View>


                </View>

                : <Text style={{ fontSize: 9 }} >SIN INFORMACIÓN  </Text>}
        </>
    );

    const TblVehiculoDetallepdf = (
        <>
            {DatodetalleVehiculos && DatodetalleVehiculos.Vehiculos?.DetalleVehiculos != null ?
                <View style={{ width: '100%' }}>




                    <View style={{ flexDirection: 'row', fontSize: 7, backgroundColor: '#e6e6e6', color: 'black' }}>

                        <Text style={{ width: '4%', height: '25px', padding: '1,10', textAlign: 'center' }}>#</Text>
                        <Text style={{ width: '15%', height: '25px', textAlign: 'left' }}>MARCA</Text>
                        <Text style={{ width: '15%', height: '25px', textAlign: 'left' }}>MODELO</Text>
                        <Text style={{ width: '10%', height: '25px', textAlign: 'left' }}>TIPO</Text>
                        <Text style={{ width: '10%', height: '25px', textAlign: 'center' }}>PATENTE</Text>
                        <Text style={{ width: '6%', height: '25px', textAlign: 'center' }}>AÑO</Text>
                        <Text style={{ width: '12%', height: '25px', textAlign: 'center' }}>COLOR</Text>
                        <Text style={{ width: '10%', height: '25px', textAlign: 'center' }}>U. TRANSF</Text>
                        <Text style={{ width: '15%', height: '25px', textAlign: 'right' }}>TASACIÓN</Text>

                    </View>


                    {DatodetalleVehiculos.Vehiculos?.DetalleVehiculos?.map((dvehiculopdf, idvehiculopdf) => (

                        <View style={{ flexDirection: 'row', fontSize: 7 }} key={idvehiculopdf}>
                            <Text style={{ width: '4%', borderBottom: '1 solid #e6e6e6 ', height: '25px', padding: '1,10', textAlign: 'center' }}>{idvehiculopdf + 1}</Text>
                            <Text style={{ width: '15%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'left' }}>{dvehiculopdf.Marca}</Text>
                            <Text style={{ width: '15%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'left' }}>{dvehiculopdf.Modelo}</Text>
                            <Text style={{ width: '10%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'left' }}>{dvehiculopdf.Tipo}</Text>
                            <Text style={{ width: '10%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{dvehiculopdf.Patente}</Text>
                            <Text style={{ width: '6%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{dvehiculopdf.AgnoFabricacion}</Text>
                            <Text style={{ width: '12%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{dvehiculopdf.Color}  {dvehiculopdf.RestoColor}</Text>
                            <Text style={{ width: '10%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'right' }}>{dvehiculopdf.UltimaTransferencia}</Text>
                            <Text style={{ width: '14%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'right' }}> {dvehiculopdf.Tasacion == '-' ? '0' : dvehiculopdf.Tasacion} </Text>

                        </View>
                    ))}

                </View>

                : <Text style={{ fontSize: 9 }} >SIN INFORMACIÓN </Text>}
        </>
    );

    const ReportePropiedadPdf = () => (

        <Document >

            <Page size="letter" style={{ paddingTop: 15, paddingBottom: 40, paddingHorizontal: 20 }}>
                <View>


                    <Image src={process.env.PUBLIC_URL + '/static/imagen/logonewp.png'} style={{ width: '100%', padding: '2' }} fixed />

                    <Text style={{ fontSize: 9, textAlign: 'right' }} fixed>FECHA IMPRESIÓN: {FechaImpresion} </Text>
                    <Text style={{ fontSize: 10, textAlign: 'right' }} render={({ pageNumber, totalPages }) => (`PÁGINA ${pageNumber} / ${totalPages}`)} fixed />

                    <View fixed>
                        <Text style={{ width: '100%', textAlign: 'center', backgroundColor: '#bbdefb', color: 'black', marginTop: 8, padding: '5,15' }}  >{datoIC.Identificacion?.IsEmpresa ? datoIC.DetalleIdentificacionEmpresa?.Nombre : datoIC.Identificacion?.Nombre} RUT {datoIC.Identificacion?.Rut}</Text>
                    </View>

                    <View style={{ width: '60%' }}>
                        <Text style={{ width: '100%', textAlign: 'left', backgroundColor: '#e6e6e6', color: 'black', marginTop: 8, padding: '5,15', fontSize: '11' }}>RESUMEN VEHICULOS</Text>
                        {TblVehiculosResumen}
                    </View>

                    <View style={{ width: '100%' }}>
                        <Text style={{ width: '100%', textAlign: 'left', backgroundColor: '#e6e6e6', color: 'black', marginTop: 8, padding: '5,15', fontSize: '11' }}>DETALLE</Text>
                        {TblVehiculoDetallepdf}
                    </View>
                    <View style={{ width: '50%', alignContent: 'left' }}>
                       {/*<Image src={process.env.PUBLIC_URL + '/static/imagen/IconoEmpresa/qrPortacheque.png'} style={{ width: '30%', padding: '5' }} />*/}
                        <Text style={{ width: '100%', textAlign: 'center', backgroundColor: '#e6e6e6', color: 'black', marginTop: 8, padding: '5,15', fontSize: '11' }}  >Nro. FOLIO: {datoIC.ID} - {uuid(datoIC.ID)}</Text>
                    </View>


                </View>


            </Page>

        </Document>

    );





    return useMemo(
        () => (
            <div>


                <PDFDownloadLink document={<ReportePropiedadPdf />} fileName={`${uuid()}.pdf`}>

                    {({ blob, url, loading, error }) => (loading ? <h2 style={{ textAlign: 'center', fontSize: '18px' }}>Ten paciencia, estamos generando el PDF... </h2> : <h2 style={{ textAlign: 'center', fontSize: '22px' }}>DESCARGAR</h2>)}

                </PDFDownloadLink>



            </div>
        ), []

    );
}

export default IcpdfDetalleVehiculos
